import { useState } from 'react';
import { GroupBox, TreeView, TextInput } from 'react95';
import { portfolio } from './portfolio';
import { projects, matchesProject } from './projects';

const ProjectTree = ({ selected, setSelected, expanded, setExpanded }) => {
  const [query, setQuery] = useState('');
  const groups = portfolio[0].items.map((group) => ({
    ...group, items: group.items.filter((item) => matchesProject(projects[item.id], query)),
  })).filter((group) => group.items.length > 0);
  const count = groups.reduce((total, group) => total + group.items.length, 0);
  const tree = [{ ...portfolio[0], items: groups }];

  return (
    <nav className="project-navigation" aria-label="Explorar projetos">
      <label className="project-search-label" htmlFor="project-search">Buscar projeto ou tecnologia</label>
      <TextInput id="project-search" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Ex.: Python, IoT, NFC…" fullWidth />
      <div className="project-tree-scroll">
        <GroupBox label="Explorador de projetos">
          <TreeView tree={tree} onNodeSelect={(_, id) => setSelected(id)} onNodeToggle={(_, ids) => setExpanded(ids)}
            expanded={query.trim() ? ['projects', ...groups.map((group) => group.id)] : expanded}
            selected={selected} className="custom-tree-view" />
        </GroupBox>
      </div>
      <p className="search-result" role="status" aria-label="Resultados da busca">{count ? `${count} projeto${count === 1 ? '' : 's'}` : 'Nenhum projeto encontrado.'}</p>
      {query && <button className="clear-search" onClick={() => setQuery('')}>Limpar busca</button>}
    </nav>
  );
};

export default ProjectTree;
